import { createSlice } from '@reduxjs/toolkit';
import { ReturnsGridStateType } from 'src/types/returnsGrid';

const initialState: ReturnsGridStateType = {
    data: null,
    allProviders: false,
    archive: false,
    loading: false,
    error: false,
};
export const returnsGridSlice = createSlice({
    name: 'returnsGrid',
    initialState,
    reducers: {
        getReturnsGridFetch: (state, action) => {
            state.loading = true;
            state.error = false;
            if (action.payload) {
                state.allProviders = action.payload.allProviders;
                state.archive = !!action.payload.archive;
            }
        },
        getReturnsGridFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getReturnsGridFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const { getReturnsGridFetch, getReturnsGridFetchSuccess, getReturnsGridFetchFailure } = returnsGridSlice.actions;

export default returnsGridSlice.reducer;
